import { DateTime } from "luxon";

function Time(input) {
  var mins = Math.floor(input / 60);
  var secs = Math.floor(input - mins * 60).toLocaleString("en-GB", {
    maximumFractionDigits: 1,
  });

  return `${mins}`.padStart(2, "0") + ":" + `${secs}`.padStart(2, "0");
}

function Percentage(input) {
  return input.toLocaleString("en-GB", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
}

function Number(input) {
  return input.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

function Timestamp(input) {
  const dt = DateTime.fromMillis(input);
  
//UTC Epoch /UnixTime to AEST
const dateObject = new Date(input)
let localDate = dateObject.toString() 
let UTCdate = dateObject.toUTCString() 
let resDate = dateObject.toISOString().replace("T"," ").substring(0, 19);

 // console.log('FH timestamp UNIX/Epoch: '+input + " dt: "+ dt+ " iso: "+dt.toISO().slice(0, 19).replace("T", " ")+ " resDate: "+resDate + ' UTCdate: '+UTCdate)

  //ORI NPAS
  return dt.toISO().slice(0, 19).replace("T", " ");
  //Fransiska Jetstar
  //return resDate;
}

function ConvertEPOCH(input) {

  let inputDateUTC = new Date(new Date(input).getFullYear() + "/" +
  ("00" + (new Date(input).getMonth() + 1)).slice(-2) + "/" +
  ("00" + new Date(input).getDate()).slice(-2) +" " +
  ("00" + new Date(input).getHours()).slice(-2) + ":" +
  ("00" + new Date(input).getMinutes()).slice(-2) + ":" +
  ("00" + new Date(input).getSeconds()).slice(-2)+ " UTC")
  const timestampFrom = new Date(inputDateUTC).getTime();
  console.log(`ConvertEPOCH from ${input} to ${timestampFrom}`)

  return timestampFrom;
}

//This is for LFS
function ConvertEPOCHUTCfromSydneyTime(input) {


  let inputDate = new Date(input)
  let utc =new Date(inputDate.getUTCFullYear(), inputDate.getUTCMonth(), inputDate.getUTCDate(), inputDate.getUTCHours(), inputDate.getUTCMinutes(), inputDate.getUTCSeconds());




  let inputDateUTC = new Date(utc.getFullYear() + "/" +
  ("00" + (utc.getMonth() + 1)).slice(-2) + "/" +
  ("00" + utc.getDate()).slice(-2) +" " +
  ("00" + utc.getHours()).slice(-2) + ":" +
  ("00" + utc.getMinutes()).slice(-2) + ":" +
  ("00" + utc.getSeconds()).slice(-2)+ " UTC")
  const timestampFrom = new Date(inputDateUTC).getTime();
  console.log(`>>>>> Please Search AEST Sydney: ${input} UTC: ${inputDateUTC} to EPOCH: ${timestampFrom}`)

  return timestampFrom;
}

export const Formatter = { Percentage, Number, Time, Timestamp, ConvertEPOCH,ConvertEPOCHUTCfromSydneyTime };
